// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { alertClasses } from '@mui/material/Alert';
import { rem } from '../../tokens/conversions';
import { snackbarColors } from './snackbarColors';
export var Snackbar = function(mode) {
    var c = snackbarColors(mode);
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5;
    var override = {
        MuiSnackbar: {
            styleOverrides: {
                root: (_obj4 = {}, _define_property(_obj4, ".".concat(alertClasses.root), {
                    borderRadius: rem(8),
                    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.25)',
                    padding: "".concat(rem(12), " ").concat(rem(16))
                }), _define_property(_obj4, ".".concat(alertClasses.message), {
                    fontSize: rem(14),
                    fontWeight: 500
                }), _define_property(_obj4, ".".concat(alertClasses.action), {
                    gap: rem(8)
                }), _define_property(_obj4, ".".concat(alertClasses.filledError), (_obj = {
                    backgroundColor: c.error.background,
                    color: c.error.text
                }, _define_property(_obj, "& .".concat(alertClasses.icon), {
                    color: c.error.icon
                }), _define_property(_obj, "& .".concat(alertClasses.action), {
                    color: c.error.action
                }), _obj)), _define_property(_obj4, ".".concat(alertClasses.filledInfo), (_obj1 = {
                    backgroundColor: c.info.background,
                    color: c.info.text
                }, _define_property(_obj1, "& .".concat(alertClasses.icon), {
                    color: c.info.icon
                }), _define_property(_obj1, "& .".concat(alertClasses.action), {
                    color: c.info.action
                }), _obj1)), _define_property(_obj4, ".".concat(alertClasses.filledSuccess), (_obj2 = {
                    backgroundColor: c.success.background,
                    color: c.success.text
                }, _define_property(_obj2, "& .".concat(alertClasses.icon), {
                    color: c.success.icon
                }), _define_property(_obj2, "& .".concat(alertClasses.action), {
                    color: c.success.action
                }), _obj2)), _define_property(_obj4, ".".concat(alertClasses.filledWarning), (_obj3 = {
                    backgroundColor: c.warning.background,
                    color: c.warning.text
                }, _define_property(_obj3, "& .".concat(alertClasses.icon), {
                    color: c.warning.icon
                }), _define_property(_obj3, "& .".concat(alertClasses.action), {
                    color: c.warning.action
                }), _obj3)), _obj4)
            }
        },
        MuiSnackbarContent: {
            styleOverrides: {
                root: (_obj5 = {
                    backgroundColor: c.default.background,
                    color: c.default.text
                }, _define_property(_obj5, "& .".concat(alertClasses.icon), {
                    color: c.default.icon
                }), _define_property(_obj5, "& .".concat(alertClasses.action), {
                    color: c.default.action
                }), _obj5)
            }
        }
    };
    return override;
};

//# sourceMappingURL=Snackbar.js.map